import { Component, OnInit } from '@angular/core';
import { Airport } from 'src/app/model/airport';
import { CurrentAptService } from 'src/app/service/current-apt.service';
import { ApiRequest, Filter, FilterComposit, FilterPredicate, Sort, SortCondition, PageInfo, ApiResponse } from '../../model/api-request';
import { AirportGeneralService } from '../../service/airport-general.service';

@Component({
  selector: 'app-airport-basedaircraft',
  templateUrl: './airport-basedaircraft.component.html',
  styleUrls: ['./airport-basedaircraft.component.css']
})
export class AirportBasedaircraftComponent implements OnInit {

  public apiRequest: ApiRequest;
  public apiResponse: ApiResponse;
  public airport: Airport;
  public airportArray: Airport[];
  public currentAirport: string;

  constructor(private data: CurrentAptService,
    private airportGeneralService: AirportGeneralService) { }

  ngOnInit() {
    this.data.currentAirport.subscribe(currentLocid => this.currentAirport = currentLocid);
    this.apiRequest = new ApiRequest();

    let filterPredicate1: Array<FilterPredicate>;
    let filterCompositArray: Array<FilterComposit>;
    let sortConditionArray: Array<SortCondition>;


    filterPredicate1 = [new FilterPredicate('AirportIdentifier', 'String', this.currentAirport, 'IsEqualTo')];
    filterCompositArray = [new FilterComposit(filterPredicate1, 'Or')];
    this.apiRequest.filter = new Filter(filterCompositArray, 'And');

    sortConditionArray = [new SortCondition('airportIdentifier', 'Ascending')];
    this.apiRequest.sort = new Sort(sortConditionArray);

    this.apiRequest.pageInfo = new PageInfo(0, 1, 5);

    this.airportGeneralService.getMultiple(this.apiRequest).subscribe((result => {
      this.airportArray = result.data as Airport[];
      this.airport = this.airportArray[0];

    }));
  }

}
